// jsm 4
const levelsTooltip = {
  Follow: 'In training',
  Assist: 'Need guidance to apply my knowledge',
  Apply: 'Apply my knowledge to solve normal complexity problems',
  Enable: 'Autonomous in the technology and able to assist others to solve problems',
  Ensure:
    'Have total domain of the technology. I can train other persons, solve complicate problems and design complex solutions'
}

export default levelsTooltip
